import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Flame, LayoutGrid, ShoppingBag, User } from "lucide-react";
import { useCart } from "../context/CartContext";

const tabs = [
    { to: "/", label: "Feed", icon: Flame, testid: "nav-feed" },
    { to: "/browse", label: "Browse", icon: LayoutGrid, testid: "nav-browse" },
    { to: "/cart", label: "Cart", icon: ShoppingBag, testid: "nav-cart" },
    { to: "/orders", label: "Me", icon: User, testid: "nav-orders" },
];

const BottomNav = () => {
    const { count, setDrawerOpen } = useCart();
    const location = useLocation();
    const onFeed = location.pathname === "/";
    // Hide nav on auth/payment full-screen flows
    if (location.pathname.startsWith("/login") || location.pathname.startsWith("/auth/") || location.pathname.startsWith("/payment/") || location.pathname.startsWith("/demo")) {
        return null;
    }
    return (
        <nav
            data-testid="bottom-nav"
            className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-50 backdrop-blur-xl ${
                onFeed ? "bg-[#0A0A0A]/60" : "bg-[#141414]/85"
            } border border-white/10 px-4 py-2.5 rounded-full flex gap-1 items-center shadow-[0_8px_30px_rgba(0,0,0,0.5)]`}
        >
            {tabs.map((t) => {
                const Icon = t.icon;
                const isCart = t.to === "/cart";
                return (
                    <NavLink
                        key={t.to}
                        to={t.to}
                        data-testid={t.testid}
                        onClick={(e) => {
                            if (isCart) {
                                e.preventDefault();
                                setDrawerOpen(true);
                            }
                        }}
                        className={({ isActive }) =>
                            `relative flex items-center gap-1.5 px-3.5 py-2 rounded-full text-xs uppercase tracking-wide font-semibold transition-all duration-200 active:scale-95 ${
                                isActive && !isCart
                                    ? "bg-[#E1FF01] text-[#0A0A0A]"
                                    : "text-white/80 hover:text-white"
                            }`
                        }
                    >
                        <Icon size={16} strokeWidth={2.4} />
                        <span className="hidden sm:inline">{t.label}</span>
                        {isCart && count > 0 && (
                            <span
                                data-testid="cart-badge"
                                className="absolute -top-1 -right-1 bg-[#FF3B30] text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center"
                            >
                                {count}
                            </span>
                        )}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default BottomNav;
